import { useStore, type ViewName } from '../state/store';

const VIEWS: { id: ViewName; label: string }[] = [
  { id: 'a1', label: 'A1' },
  { id: 'a2', label: 'A2' },
  { id: 'timeline', label: 'Timeline' },
  { id: 'stage', label: 'Stage Manager' },
  { id: 'cues', label: 'Cues' },
];

interface HeaderProps {
  onOpenSession: () => void;
  onOpenMessages: () => void;
  onOpenShortcuts: () => void;
  unread: number;
}

export default function Header({
  onOpenSession, onOpenMessages, onOpenShortcuts, unread,
}: HeaderProps) {
  const view = useStore(s => s.view);
  const setView = useStore(s => s.setView);
  const connected = useStore(s => s.connected);
  const identity = useStore(s => s.identity);

  return (
    <header className="header">
      <div className="brand">mic<span>Plot</span></div>

      <nav className="nav">
        {VIEWS.map(v => (
          <button key={v.id} aria-current={view === v.id} onClick={() => setView(v.id)}>
            {v.label}
          </button>
        ))}
      </nav>

      <div className="header-spacer" />

      <button className="btn sm" onClick={onOpenMessages}
              title="Messages between positions">
        Messages{unread > 0 && <> <span className="msg-badge">{unread}</span></>}
      </button>
      <button className="btn sm" onClick={onOpenShortcuts}
              title="Keyboard shortcuts" aria-label="Keyboard shortcuts">?</button>
      <button className="btn sm" onClick={onOpenSession}>Show</button>
      <span className="code-pill">{identity?.code}</span>
      <span className="status">
        <span className={`dot ${connected ? 'on' : ''}`} />
        {connected ? 'Live' : 'Reconnecting…'}
      </span>
    </header>
  );
}
